import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedin, FaYoutube, FaTiktok } from "react-icons/fa";
import SEO from '../../components/SEO';


export default function SocialMediaMarketing() {
  return (
      <>
    <SEO title="Social Media Marketing" />
    <div className="w-full">
      {/* Hero Section */}
      <div className="bg-[#8cc540] py-16 px-4 text-white text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Social Media Marketing (SMM)
        </h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          Build relationships, generate leads, and grow your business through strategic social media campaigns on platforms your audience uses daily.
        </p>
      </div>

      {/* Content Area */}
      <div className="max-w-6xl mx-auto px-4 py-12 space-y-12 text-gray-700 leading-relaxed">
        {/* What is SMM */}
        <section>
          <h2 className="text-2xl font-bold text-[#0a3c6d] mb-3">
            What is Social Media Marketing?
          </h2>
          <p>
            Social Media Marketing (SMM) is the art of using social platforms to tell your brand story, build trust, and convert followers into loyal customers.
            From clever captions to high-converting ad campaigns, it’s about engaging your audience in the moments that matter most.
          </p>
        </section>

        {/* Key Benefits */}
        <section>
          <h2 className="text-2xl font-bold text-[#0a3c6d] mb-3">Key Benefits of SMM</h2>
          <ul className="grid sm:grid-cols-2 gap-4 text-sm md:text-base">
            {[
              "Increased brand awareness and visibility",
              "Higher website traffic and lead generation",
              "Real-time customer engagement and feedback",
              "Improved brand loyalty and trust",
              "Boosted conversion rates through targeted ads",
              "Cost-effective marketing with measurable ROI"
            ].map((benefit, i) => (
              <li
                key={i}
                className="p-4 bg-[#f8fff1] border-l-4 border-[#8cc540] rounded shadow-sm"
              >
                {benefit}
              </li>
            ))}
          </ul>
        </section>

        {/* Our Services */}
        <section>
          <h2 className="text-2xl font-bold text-[#0a3c6d] mb-3">What We Offer</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>Strategic social media planning & audits</li>
            <li>Account setup and branding (Facebook, Insta, LinkedIn, etc.)</li>
            <li>Custom content creation (posts, reels, stories, carousels)</li>
            <li>Scheduled posting and smart automation</li>
            <li>Paid campaign management (Meta Ads, LinkedIn Ads)</li>
            <li>Performance tracking, analytics & monthly reporting</li>
            <li>Community management (comments, DMs, and reviews)</li>
          </ul>
        </section>

        {/* Platforms */}
        <section>
          <h2 className="text-2xl font-bold text-[#0a3c6d] mb-3">
            Platforms We Specialize In
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { title: "Facebook & Instagram", icon: <FaFacebookF />, desc: "Rich visuals, reels, and Meta Ads targeting." },
              { title: "LinkedIn", icon: <FaLinkedin />, desc: "B2B authority building through professional content." },
              { title: "TikTok & YouTube", icon: <FaYoutube />, desc: "Video storytelling and viral content strategies." },
            ].map((platform, index) => (
              <div
                key={index}
                className="p-5 bg-[#f8fff1] border-l-4 border-[#8cc540] shadow rounded flex flex-col gap-2"
              >
                <div className="text-[#0a3c6d] text-2xl">{platform.icon}</div>
                <h3 className="font-semibold text-[#0a3c6d]">{platform.title}</h3>
                <p className="text-sm text-gray-600">{platform.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Industry Use Cases */}
        <section>
          <h2 className="text-2xl font-bold text-[#0a3c6d] mb-3">Who Can Benefit?</h2>
          <p>
            Whether you're a startup, e-commerce brand, service-based business, or a large enterprise,
            our SMM services help you connect, convert, and grow. Ideal for real estate, healthcare, education,
            coaching, and lifestyle brands.
          </p>
        </section>

        {/* Quote */}
        <section className="bg-[#f7fdf3] border-l-4 border-[#8cc540] p-6 rounded-md shadow-sm">
          <p className="text-[#0a3c6d] font-medium text-lg italic">
            “Social media is about the people! Not about your business. Provide for the people and the people will provide for you.”
          </p>
          <p className="text-sm text-gray-500 mt-2">– Matt Goulart</p>
        </section>

        {/* Call to Action */}
        <div className="text-center pt-10">
          <Link
            to="/contact-us"
            className="inline-block bg-[#8cc540] hover:bg-[#79a436] text-white font-semibold px-8 py-3 rounded-full transition"
          >
            Let’s Build Your Brand Together →
          </Link>
        </div>
      </div>
    </div>
    </>
  );
}
